import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { BookOpen, Loader2 } from "lucide-react";
import { API, authHeaders } from "@/constants/roles";
import { ManualReader } from "@/components/manuals/ManualReader";

// Read-only manuals home for staff: lists manuals assigned to their role/account, opens the reader.
export const ManualsPage = () => {
  const [manuals, setManuals] = useState(null);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/manuals`, { headers: authHeaders() }).then((r) => setManuals(r.data)).catch(() => setManuals([]));
  }, []);
  useEffect(load, [load]);

  if (openId) {
    return <ManualReader manualId={openId} onBack={() => setOpenId(null)} />;
  }

  return (
    <div data-testid="manuals-page">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cyan-500/15 text-cyan-300">
          <BookOpen className="h-5 w-5" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-[var(--pv-text)]">Manuals & SOPs</h1>
          <p className="mt-1 text-sm text-[var(--pv-text-4)]">Internal playbooks the owner has shared with you. Read-only.</p>
        </div>
      </div>

      {!manuals ? (
        <p className="py-16 text-center"><Loader2 className="mx-auto h-5 w-5 animate-spin text-cyan-400" /></p>
      ) : manuals.length === 0 ? (
        <p data-testid="manuals-page-empty" className="mt-6 rounded-3xl border border-dashed border-[var(--pv-border-strong)] bg-[var(--pv-card)] py-16 text-center text-sm text-[var(--pv-text-4)]">
          No manuals have been shared with your role yet.
        </p>
      ) : (
        <div data-testid="manuals-page-list" className="mt-6 grid gap-4 sm:grid-cols-2">
          {manuals.map((m) => (
            <button key={m.id} data-testid={`manual-open-${m.id}`} onClick={() => setOpenId(m.id)} className="rounded-3xl border border-[var(--pv-border)] bg-[var(--pv-card)] p-6 text-left transition-colors hover:border-cyan-500/30">
              <div className="flex items-start justify-between gap-3">
                <p className="font-display text-base font-bold text-[var(--pv-text)]">{m.title}</p>
                <BookOpen className="h-4 w-4 shrink-0 text-cyan-400" />
              </div>
              {m.description && <p className="mt-1.5 line-clamp-2 text-xs text-[var(--pv-text-4)]">{m.description}</p>}
              <span className="mt-3 inline-block rounded-full border border-[var(--pv-border)] bg-[var(--pv-subtle)] px-2 py-0.5 text-[10px] font-bold text-[var(--pv-text-3)]">
                {m.published} section{m.published === 1 ? "" : "s"}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
